module.exports = __webpack_public_path__ + "img/vegetable-sweet-potatoes-190x100.c97b0c2d.jpg";